/**
 * @file API service — manufacturingProcessesPublicService.
 * GET /manufacturing-processes?materialId= — public, no auth.
 */

import axiosClient from "../api/axiosClient";
import { API_URLS } from "../constants/apiUrls";

/** Type definition — Manufacturing Process Row. */
export type ManufacturingProcessRow = {
  id: number;
  materialId: number;
  name: string;
  sortOrder: number;
};

/** Exported function — fetch Manufacturing Processes By Material Id. */
export async function fetchManufacturingProcessesByMaterialId(
  materialId: number
): Promise<ManufacturingProcessRow[]> {
  if (!Number.isFinite(materialId) || materialId <= 0) return [];

  const res = await axiosClient.get(API_URLS.MANUFACTURING_PROCESSES, {
    params: { materialId },
  });

  const data = res?.data?.data ?? res?.data;
  const processes = data?.processes;
  if (!Array.isArray(processes)) return [];

  return processes
    .map((p: Record<string, unknown>) => ({
      id: Number(p.id),
      materialId: Number(p.materialId),
      name: String(p.name ?? "").trim(),
      sortOrder: Number(p.sortOrder) || 0,
    }))
    .filter((p) => Number.isFinite(p.id) && p.id > 0 && p.name)
    .sort((a, b) => a.sortOrder - b.sortOrder);
}
